(function(){
  var root=document.documentElement;
  if(!('IntersectionObserver' in window)){root.classList.remove('sc-js');return;}
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
  },{rootMargin:'0px 0px -6% 0px',threshold:0.06});
  function scan(){ document.querySelectorAll('.sc-reveal:not(.is-in)').forEach(function(el,i){ el.style.transitionDelay=(el.closest('.sc-tiles__grid,.sc-features__grid')? (Array.prototype.indexOf.call(el.parentNode.children,el)%4)*90 : 0)+'ms'; io.observe(el); }); }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',scan);}else{scan();}
  document.addEventListener('shopify:section:load',scan);
})();
